export const GET_BUNDLES_ALL= 'GET_BUNDLES_ALL';
export const GET_BUNDLES_ALL_SUCCEEDED = 'GET_BUNDLES_ALL_SUCCEEDED';
export const GET_BUNDLES_ALL_FAIL = 'GET_BUNDLES_ALL_FAIL';
export const GET_BUNDLE_PAYMENT_OPTIONS= 'GET_BUNDLE_PAYMENT_OPTIONS';
export const GET_BUNDLE_PAYMENT_OPTIONS_SUCCEEDED = 'GET_BUNDLE_PAYMENT_OPTIONS_SUCCEEDED';

export const BUY_BUNDLE= 'BUY_BUNDLE';
export const BUY_BUNDLE_SUCCEEDED= 'BUY_BUNDLE_SUCCEEDED';

export const CONFIRM_BUNDLE_PAYMENT = 'CONFIRM_BUNDLE_PAYMENT';
export const CONFIRM_BUNDLE_PAYMENT_SUCCEEDED = 'CONFIRM_BUNDLE_PAYMENT_SUCCEEDED';

export const CANCEL_BUNDLE_PAYMENT = 'CANCEL_BUNDLE_PAYMENT';
export const CHECK_BUNDLE_PAYMENT_STATUS = 'CHECK_BUNDLE_PAYMENT_STATUS';
export const UPDATE_BUNDLE_PAYMENT_STATUS = 'UPDATE_BUNDLE_PAYMENT_STATUS';

export const SELECT_BUNDLE = 'SELECT_BUNDLE';
